/**
 * ITag - Simple wrapper for FontAwesome icon class names
 *
 * @param {Object} props
 * @param {string} props.ClassName - FontAwesome icon class string (e.g., "fas fa-home")
 * @returns {React.ReactElement} <i> element with provided classes
 */
function ITag({ClassName}){
  return <i className={ClassName}></i>
}
export default ITag